import React from 'react';
import videoSrc from '../../assets/rideCORE_Home.mp4';
import logo from '../../assets/core-kiteboarding_logo.svg';

const Home = () => {
	return (
		<>
		<video autoPlay loop muted playsInline className="backgroundVideo">
			<source src={videoSrc} type="video/mp4" />
			Your browser does not support the video tag.
		</video>
		<div className="home">

			<a href="/">
				<img src={logo} alt="Core Logo" height="160" width="160" />
			</a>
			<h1>WILLKOMMEN ZUM NEUEN SHAREPOINT-ORDNER-TOOL VON CORE.</h1>
			<p>Mithilfe dieses kleinen Tools, können Ordner mitsamt deren Unterordner angelegt werden. <br />Dabei werden automatisch auch gleich die richtigen Rechte für die Unterordner vergeben.</p>
			<section>
				<Resource
					title="KUNDE"
					description="Um einen neuen Kundenordner anzulegen, klicke hier."
					link="/NewFolder/customer"
				/>
				<Resource
					title="LIEFERANT"
					description="Um einen neuen Lieferantenordner anzulegen, klicke hier."
					link="/NewFolder/supplier"
				/>
				<Resource
					title="PRODUKT"
					description="Um einen neuen Produktordner anzulegen, klicke hier."
					link="/NewFolder/product"
				/>
			</section>

		</div>
		</>
	);
};

const Resource = props => {
	return (
		<a href={props.link} class="resource">
			<h2>{props.title}</h2>
			<p>{props.description}</p>
		</a>
	);
};

export default Home;
